// PARAQTA — Pomodoro / Free таймер.
//
// State module ішінде ғана сақталады (window-ге шығармаймыз).
// localStorage кілті: 'timer_daily' — өзгеріссіз қалады.

import { toast } from '../../utils/toast.js';

let timerInterval = null;
let timerSeconds = 0;
let timerRunning = false;
let timerMode = 'free';
let pomoCount = 0;
let pomoPhase = 'work';

export function setTimerMode(mode, btn) {
  timerMode = mode;
  timerReset();
  document.querySelectorAll('.timer-mode button').forEach(b => b.classList.remove('on'));
  if (btn) btn.classList.add('on');
  document.getElementById('pomoDots').style.display = mode === 'pomo' ? 'flex' : 'none';
  pomoCount = 0;
  pomoPhase = 'work';
  updatePomoDots();
}

export function timerStart() {
  if (timerRunning) return;
  timerRunning = true;
  document.getElementById('btnTimerStart').style.display = 'none';
  document.getElementById('btnTimerPause').style.display = 'inline-block';
  timerInterval = setInterval(() => {
    timerSeconds += 1;
    updateTimerDisplay();
    if (timerMode === 'pomo') {
      const limit = pomoPhase === 'work' ? 25 * 60 : 5 * 60;
      if (timerSeconds >= limit) {
        timerPause();
        if (pomoPhase === 'work') {
          pomoCount += 1;
          updatePomoDots();
          pomoPhase = 'break';
          toast('Үзіліс! 5 мин дем ал');
        } else {
          pomoPhase = 'work';
          toast('Оқуды жалғастыр!');
        }
        timerSeconds = 0;
        updateTimerDisplay();
      }
    }
  }, 1000);
}

export function timerPause() {
  timerRunning = false;
  clearInterval(timerInterval);
  document.getElementById('btnTimerStart').style.display = 'inline-block';
  document.getElementById('btnTimerPause').style.display = 'none';

  const today = new Date().toISOString().split('T')[0];
  const saved = JSON.parse(localStorage.getItem('timer_daily') || '{}');
  saved[today] = (saved[today] || 0) + timerSeconds;
  localStorage.setItem('timer_daily', JSON.stringify(saved));

  // Серверге жіберу (рейтинг үшін) — тек 30+ сек және авторизацияланған
  if (timerSeconds >= 30 && window.currentUser) {
    fetch('/api/timer/log', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ seconds: timerSeconds }),
    }).catch(() => {});
  }

  timerSeconds = 0;
  loadTimerStats();
}

export function timerReset() {
  timerRunning = false;
  clearInterval(timerInterval);
  timerSeconds = 0;
  updateTimerDisplay();
  document.getElementById('btnTimerStart').style.display = 'inline-block';
  document.getElementById('btnTimerPause').style.display = 'none';
}

export function updateTimerDisplay() {
  const h = Math.floor(timerSeconds / 3600);
  const m = Math.floor((timerSeconds % 3600) / 60);
  const s = timerSeconds % 60;
  const el = document.getElementById('timerDisplay');
  if (el) el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
}

export function updatePomoDots() {
  document.querySelectorAll('.pomo-dot').forEach((d, i) => {
    d.classList.toggle('done', i < pomoCount);
  });
}

export function loadTimerStats() {
  const saved = JSON.parse(localStorage.getItem('timer_daily') || '{}');
  const today = new Date().toISOString().split('T')[0];
  const todayEl = document.getElementById('todayTime');
  if (todayEl) todayEl.textContent = Math.round((saved[today] || 0) / 60) + ' мин';

  let wk = 0;
  const now = new Date();
  for (let i = 0; i < 7; i += 1) {
    const d = new Date(now);
    d.setDate(d.getDate() - i);
    wk += saved[d.toISOString().split('T')[0]] || 0;
  }
  const weekEl = document.getElementById('weekTime');
  if (weekEl) weekEl.textContent = (wk / 3600).toFixed(1) + ' сағ';
}
